export const resolveVideoOrientation = ({
  embeddedInWebView,
  viewportWidth,
  viewportHeight,
  screenOrientationType,
}) => {
  const hasViewport =
    Number.isFinite(viewportWidth) &&
    Number.isFinite(viewportHeight) &&
    viewportWidth > 0 &&
    viewportHeight > 0;

  // React Native WebViews can expose a stale Screen Orientation API value.
  // Once native rotation resizes the WebView, its viewport aspect ratio is the
  // reliable representation of what the user is actually seeing.
  if (embeddedInWebView && hasViewport) {
    return viewportWidth > viewportHeight ? "landscape" : "portrait";
  }

  if (typeof screenOrientationType === "string") {
    return screenOrientationType.includes("landscape")
      ? "landscape"
      : "portrait";
  }

  return hasViewport && viewportWidth > viewportHeight
    ? "landscape"
    : "portrait";
};
